import { ApiSubUrls, Apis } from 'enums/api-constants'
import { CapabilitiesData } from 'pages/fulfillment/helpers'
import { fetchGeneralData } from 'queries/fetchData'
import {
    GreenfieldCardTable,
    StoreFulfillmentLocationData,
} from 'types/store-fulfillment'

export const fetchStoreFulfillment = fetchGeneralData<
    StoreFulfillmentLocationData[]
>(`${ApiSubUrls[Apis.FULFILLMENT]}`)
export const fetchStoreFulfillmentPickupHistorical =
    fetchGeneralData<GreenfieldCardTable>(
        `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
    )
export const fetchStoreFulfillmentShipOnTime =
    fetchGeneralData<GreenfieldCardTable>(
        `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
    )
export const fetchFulfillmentCapabilities = fetchGeneralData<CapabilitiesData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/fulfillment_capabilities/`,
)
export const fetchFulfillmentCapabilitiesRGD =
    fetchGeneralData<CapabilitiesData>(
        `${ApiSubUrls[Apis.AGGREGATIONS]}/fulfillment_capabilities/non_stores/`,
    )
